// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../common/components/authenticated-page';
import Home from './components/home';
import React from 'react';

const HomePage = props => (

    <AuthenticatedPage className="home-page">
        <Home {...props} />
    </AuthenticatedPage>

);

export default HomePage;
